module.exports = __webpack_public_path__ + "static/img/SN.4775a47e.svg";